export default {
  colors: {
    background: '#202225',
    backgroundInverted: '#F2F3F5',
    card: '#2F3136',
    cardInverted: '#FFFFFF',
    text: '#FAFAFA',
    textFaint: '#B0B2B6',
    textFaintInverted: '#7f848a',
    textLight: '#FAFAFA',
    textDark: '#4B4B4C',
    textInverted: '#4B4B4C',
    green: '#43b581',
    red: '#F04747',
    linkColor: '#1e96fc',
  },
  borderRadius: '0.5rem',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
}